import * as React from "react";
import {
  TextField,
  FunctionField,
  DateField,
  EditButton,
  TextInput,
  SelectInput,
  NumberInput
} from "react-admin";
import { NumberRangeInput } from "src/components/input";
import { ProductTypeEnum, StockStatusEnum } from "src/common/enum";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";
import { EditableDatagrid, RowForm } from "src/enterprise/ra-editable-datagrid";
import Transformer from "src/common/Transformer";

const listFilters = [
  <TextInput source="search" label="Search" alwaysOn />,
  <SelectInput source="product.type" choices={ProductTypeEnum} label="Type"/>,
  <SelectInput source="product.stock_status" choices={StockStatusEnum} label="Stock Status"/>,
  <NumberRangeInput source="quantity" label="Quantity" />,
  <NumberRangeInput source="reserved_quantity" label="Reserved Quantity" />,
];

export const SampleList = (props) => {
  return (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
      <EditableDatagrid editForm={<SampleEditForm />} mutationMode="pessimistic" noDelete rowClick="edit" actions={<></>}>
        <TextField source="id" />
        <TextField source="product.name" label="Name" />
        <TextField source="product.sku" label="SKU" />
        <FunctionField
          label="Type"
          source="product.type"
          render={(record) =>
            ProductTypeEnum.find((x) => x.id === record.product.type)?.name
          }
        />
        <FunctionField
          label="Stock Status"
          source="product.stock_status"
          render={(record) =>
            StockStatusEnum.find((x) => x.id === record.product.stock_status)?.name
          }
        />
        <TextField source="quantity" />
        <TextField source="reserved_quantity_total" sortable={false}/>
        <DateField source="created_at" label="Created At" />
        <IfCanAccess action="edit">
          <EditButton />
        </IfCanAccess>
      </EditableDatagrid >
    </List>
  );
};

const SampleEditForm = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: [
        "id",
        "createdAt",
        "createdBy",
        "updatedAt",
        "updatedBy",
        "reserved",
        "reservedQuantityTotal"
      ],
      update: {
        product: data.product.id,
      },
    });

    return data;
  };

  return (
    <RowForm transform={transform}>
          <TextField source="id" />
          <TextField source="product.name" label="Name" />
          <TextField source="product.sku" label="SKU" />
          <FunctionField
            label="Type"
            source="product.type"
            render={(record) =>
              ProductTypeEnum.find((x) => x.id === record.product.type)?.name
            }
          />
          <FunctionField
            label="Stock Status"
            source="product.stock_status"
            render={(record) =>
              StockStatusEnum.find((x) => x.id === record.product.stock_status)?.name
            }
          />
          <NumberInput source="quantity" required/>
          <TextField source="reserved_quantity_total"/>
          <DateField source="created_at" label="Created At" />
    </RowForm>
  );
};